module.exports = __webpack_public_path__ + "/img/envelope-icon.df2f362be8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/envelope-icon.png
// module id = 1390
// module chunks = 0